<template>
  <div>
    <div v-if="po" class="view-purchase-order">
      <approval-activity :order="order" :po="po" />

      <purchase-order-detail :order="order" :po="po">
        <template v-slot:action>
          <qtm-btn
            v-if="showCOButton"
            class="mr-8"
            secondary
            :to="{ name: 'orders-id-change-order', params: { id: order.id } }"
          >
            Change Order
          </qtm-btn>
        </template>
      </purchase-order-detail>

      <purchase-order-items :order="order" :po="po" />

      <change-orders-list :order="order" :po="po" />

      <order-info-summary v-if="!order.isDirectToPO" :order="order" />

      <order-summary v-if="order.scope_of_work" :scope-of-work="order.scope_of_work" />

      <quotes-review v-if="!order.isDirectToPO" :order="order" />

      <qtm-content-block v-if="order.requiresAdjustments" title="Invited Vendors">
        <enter-vendor-quotes-table :order="order" />
      </qtm-content-block>
    </div>
    <v-alert v-else max-width="45rem" type="error">
      This order has no purchase order, please visit the admin.
    </v-alert>
  </div>
</template>

<script setup lang="ts">
import ApprovalActivity from '@/components/orders/approval-activity.vue'
import EnterVendorQuotesTable from '@/components/vendors/enter-vendor-quotes-table.vue'
import ChangeOrdersList from '@/components/purchase-orders/change-orders-list.vue'
import OrderInfoSummary from '@/components/orders/order-info-summary.vue'
import OrderSummary from '@/components/orders/order-summary.vue'
import PurchaseOrderDetail from '@/components/purchase-orders/purchase-order-detail.vue'
import PurchaseOrderItems from '@/components/purchase-orders/purchase-order-items.vue'
import QuotesReview from '@/components/quotes/quotes-review.vue'
import type { Order } from '@quotetome/materials-api'

export interface Props {
  order: Order
}
const props = defineProps<Props>()

const po = computed(() => {
  return props.order.hasPurchaseOrder ? props.order.pos[0] : undefined
})

const showCOButton = computed(() => {
  if (!po.value) {
    return false
  }

  if (po.value.jobsite?.accounting_id && !po.value.latest_change_order?.accounting_success) {
    return false
  }

  return po.value.canIssueChangeOrder
})
</script>

<style lang="scss" scoped>
.view-purchase-order > * {
  margin-bottom: 1rem;
}
</style>
